import { Tags } from "../enum/tags";
import { CreateAccessRequest } from "./dtos/accessAutomation.dto";
import { CreateAccessResponse } from "./dtos/accessRequest.dto";
import {
  CreateOperatorDTO,
  CreateOperatorResponseDTO,
  OperatorDTO,
} from "./dtos/operator.dto";
import { apiSlice } from "./http";

export const accessAutomation = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getOperators: builder.query<OperatorDTO[], string>({
      query: (cpf) => {
        return {
          url: `/operator/${cpf}`,
          method: "GET",
        };
      },
      providesTags: [Tags.NSU],
    }),
    createOperator: builder.mutation<
      CreateOperatorResponseDTO,
      CreateOperatorDTO
    >({
      query: (data) => {
        return {
          url: `/operator/store/${data.store_code}/operator`,
          method: "POST",
          body: data,
        };
      },
      invalidatesTags: [Tags.ACCESS_REQUEST],
    }),
    createAccess: builder.mutation<CreateAccessResponse, CreateAccessRequest>({
      query: (data) => {
        return {
          url: `/access-automation/store/${data?.body?.create?.storeCode}/access`,
          method: "POST",
          body: data.body, // Agora contém { create: {...}, update: {...} }
        };
      },
      invalidatesTags: [Tags.ACCESS_REQUEST],
    }),
  }),
  overrideExisting: true,
});

export const { useGetOperatorsQuery, useCreateAccessMutation } =
  accessAutomation;
